<template>
    <v-card flat color="white">
        <v-card-text class="pl-0 pt-0">
            <v-form
                ref="form"
                v-model="validUernameForm"
                lazy-validation
                @submit.prevent="changeUsername"
            >
                <p class="text-body-2 mb-1">
                    {{ $t('user_settings.change_name.first_name_field') }}
                </p>
                <v-text-field
                    v-model="firstName"
                    :rules="rules.name_rules"
                    :placeholder="currentFirstName"
                    autocomplete="first-name"
                    type="text"
                    class="w-100"
                    required
                    counter
                    density="compact"
                    persistent-placeholder
                    variant="outlined"
                ></v-text-field>
                <p class="text-body-2 mb-1">
                    {{ $t('user_settings.change_name.last_name_field') }}
                </p>
                <v-text-field
                    v-model="lastName"
                    :rules="rules.name_rules"
                    :placeholder="currentLastName"
                    autocomplete="last-name"
                    type="text"
                    class="w-100"
                    required
                    counter
                    density="compact"
                    persistent-placeholder
                    variant="outlined"
                ></v-text-field>

                <ButtonComponent
                    type="submit"
                    color="primary"
                    :disabled="!validUernameForm"
                    :loading="loading"
                >
                    {{ $t('user_settings.change_name.change_name_button') }}
                </ButtonComponent>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { useUserStore } from '@/stores/user';
import { toast } from 'vue3-toastify';
import { defaultErrorHandling } from '@/assets/js/utils';
import ButtonComponent from '@/components/utils/buttons/ButtonComponent.vue';

export default {
    name: 'ChangeUsername',
    components: {
        ButtonComponent,
    },
    data: () => ({
        user_store: useUserStore(),
        firstName: '',
        lastName: '',
        loading: false,
        validUernameForm: false,
        rules: {
            required: (value) => !!value || 'Must be specified.',
            name_rules: [
                (v) => !!v || 'Please specify.',
                (v) => (v && v.length >= 1) || 'Min 1 letter',
                (v) => (v && v.length <= 20) || 'Max 20 letters',
            ],
        },
    }),
    computed: {
        currentFirstName() {
            return this.user_store.get_user.first_name;
        },
        currentLastName() {
            return this.user_store.get_user.last_name;
        },
    },
    mounted() {
        this.firstName = this.currentFirstName;
        this.lastName = this.currentLastName;
    },
    methods: {
        async changeUsername() {
            this.loading = true;
            this.user_store
                .update_user_data(this.firstName, this.lastName)
                .then(() => {
                    toast.success(this.$t('alerts.success.name_changed'));
                })
                .catch(defaultErrorHandling())
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style></style>
